import { SubmittedAgendaItemsPage } from "./SubmittedAgendaItemsPage";

export default SubmittedAgendaItemsPage;
